import {Model} from 'vue-mc';


/**
 * ItProject model
 */
export default class fileModel extends Model {

    defaults() {
        return {

        }
    }

    // Route configuration
    routes() {
        return {
            getFile:"files/getFile/",
            getUserGuideDocumentId:"userGuides/getByClientType",
        }
    }
}


// WEBPACK FOOTER //
// ./src/models/fileModel.js